import React from 'react';

class AlreadyAnswerMessage extends React.PureComponent {
  render() {
    return <h1>{this.props.children}</h1>;
  }
}

export default AlreadyAnswerMessage;



// WEBPACK FOOTER //
// ./components/during-stay-survey/AlreadyAnswerMessage.js